import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import api from "../api";
import IndividualResults from "./results/IndividualResults";
import PairResults from "./results/PairResults";
import BestBallResults from "./results/BestBallResults";
import MatchResults from "./results/MatchResults";
import SkinsResults from "./results/SkinsResults";
import TeamResults from "./results/TeamResults";
import GroupBestTwoResults from "./results/GroupBestTwoResults";

// Singles Match Play removed 2026-09-04 — no opponent-pairing concept for
// it at all, falls through to the default IndividualResults below, exactly
// like Singles Stableford.
const MATCH_PLAY = ["Better Ball Match Play","Fourball Match Play","Foursomes Match Play","Greensomes Match Play","Team Match Play"];
const SKINS = ["Skins"];
const PAIR = ["Foursomes Stableford","Foursomes Medal","Greensomes Stableford","Greensomes Medal"];
const BEST_BALL = ["Better Ball Stableford","Fourball Better Ball Stableford","Better Ball Medal","Better Ball Stroke Play","Fourball Stroke Play"];
const TEAM = ["Team Stableford","Team Medal","Team Aggregate Stableford","Team Aggregate Stroke Play","Texas Scramble","Texas Scramble (4 players)","Texas Scramble (3 players)","Texas Scramble Medal (4 players)","Texas Scramble Medal (3 players)"];

// Only these formats have a genuine "group of 4, best 2 scores per hole"
// secondary prize alongside individual play — see Layout.jsx's matching
// GROUP_WINNER_FORMATS. Every other format either has no group concept
// (Match Play is won/lost/halved) or already has its own dedicated results
// page (Team/Pair/Best Ball), so ?view=group is ignored for them.
const GROUP_WINNER_FORMATS = [];

// Four players, no pairing — best 2 individual Stableford/net scores per
// hole count toward the team total. Uses the same GroupBestTwoResults
// engine already built for the (currently unused) group-winner secondary
// view above, here as the format's own primary results page.
const GROUP_BEST_2_OF_4 = ["Team Stableford (Best 2 of 4)"];

export default function Results() {
  const [gameType, setGameType] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const view = new URLSearchParams(location.search).get("view");

  useEffect(() => {
    api.get("/events/current").then(res => {
      if (res.data) setGameType(res.data.game_type || "");
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Layout><div className="p-4 text-gray-500">Loading...</div></Layout>;
  if (!gameType) return <Layout><div className="p-4 text-red-500">No active event.</div></Layout>;

  if (view === "group" && GROUP_WINNER_FORMATS.includes(gameType)) return <GroupBestTwoResults />;
  if (GROUP_BEST_2_OF_4.includes(gameType)) return <GroupBestTwoResults />;

  if (MATCH_PLAY.includes(gameType)) return <MatchResults />;
  if (SKINS.includes(gameType)) return <SkinsResults />;
  if (PAIR.includes(gameType)) return <PairResults />;
  if (BEST_BALL.includes(gameType)) return <BestBallResults />;
  if (TEAM.includes(gameType)) return <TeamResults />;
  return <IndividualResults />;
}
